import {svgIconWrapper} from '../svg-icon-wrapper';

import PhoneRegular from './phone-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PhoneRegular {...validProps} />;
}

SvgComponent.iconName = 'phoneRegular';

export const PhoneRegularIcon = svgIconWrapper(SvgComponent);
